// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.time-grid-wrapper {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  justify-content: center;
  margin-bottom: 1rem;
}

.date-grid-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: flex-start;
  margin-bottom: 1rem;
}

.date-button {
  font-family: AppFontBold, sans-serif;
  border: 2px solid #000;
  border-radius: 12px;
  padding: 10px 16px;
  background-color: white;
  cursor: pointer;
  text-align: center;
  font-size: 14px;
  text-transform: capitalize;
  white-space: nowrap;
  transition: all 0.2s ease-in-out;
}

.date-button.selected {
  border-color: #9c774d;
  background-color: #f9f5f0;
}

.time-button {
  font-family: AppFontBold, sans-serif;
  border: 2px solid #000;
  border-radius: 12px;
  padding: 12px 0;
  background-color: white;
  cursor: pointer;
  text-align: center;
  font-size: 16px;
  transition: all 0.2s ease-in-out;
}

.time-button.selected {
  border-color: #9c774d;
  background-color: #f9f5f0;
}

.toggle-button {
  text-align: center;
  font-family: AppFontBold, sans-serif;
  cursor: pointer;
  font-size: 14px;
  color: #9c774d;
  text-decoration: underline;
  margin-top: 1rem;
  transition: opacity 0.2s;
}

.header-color {
  font-family: AppFontBold, sans-serif;
  font-size: 18px;
  margin-bottom: 1rem;
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/app/components/select-date-formcontrol/select-date-formcontrol.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,2BAAA;EACA,mBAAA;AACF;;AAEA;EACE,oCAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;EACA,mBAAA;EACA,gCAAA;AACF;;AAEA;EACE,qBAAA;EACA,yBAAA;AACF;;AAEA;EACE,oCAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;AACF;;AAEA;EACE,qBAAA;EACA,yBAAA;AACF;;AAEA;EACE,kBAAA;EACA,oCAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,0BAAA;EACA,gBAAA;EACA,wBAAA;AACF;;AAEA;EACE,oCAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AACF","sourcesContent":[".time-grid-wrapper {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr); // zwei Spalten\n  gap: 12px;\n  justify-content: center;\n  margin-bottom: 1rem;\n}\n\n.date-grid-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  justify-content: flex-start;\n  margin-bottom: 1rem;\n}\n\n.date-button {\n  font-family: AppFontBold, sans-serif;\n  border: 2px solid #000;\n  border-radius: 12px;\n  padding: 10px 16px;\n  background-color: white;\n  cursor: pointer;\n  text-align: center;\n  font-size: 14px;\n  text-transform: capitalize;\n  white-space: nowrap;\n  transition: all 0.2s ease-in-out;\n}\n\n.date-button.selected {\n  border-color: #9c774d;\n  background-color: #f9f5f0;\n}\n\n.time-button {\n  font-family: AppFontBold, sans-serif;\n  border: 2px solid #000;\n  border-radius: 12px;\n  padding: 12px 0;\n  background-color: white;\n  cursor: pointer;\n  text-align: center;\n  font-size: 16px;\n  transition: all 0.2s ease-in-out;\n}\n\n.time-button.selected {\n  border-color: #9c774d;\n  background-color: #f9f5f0;\n}\n\n.toggle-button {\n  text-align: center;\n  font-family: AppFontBold, sans-serif;\n  cursor: pointer;\n  font-size: 14px;\n  color: #9c774d;\n  text-decoration: underline;\n  margin-top: 1rem;\n  transition: opacity 0.2s;\n}\n\n.header-color {\n  font-family: AppFontBold, sans-serif;\n  font-size: 18px;\n  margin-bottom: 1rem;\n  text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
